var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRPool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "35px",
    viewBox: "0 0 57 35",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.0776101 20.1579L0.0776101 19.4297L32.0556 0.0218278L56.9249 15.1673L56.9249 15.9023L25.0212 34.9919L0.0776101 20.1579Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "none",
    fill: "#FFFFFF",
    xlinkHref: "#path_1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "#FDFDFD",
    strokeWidth: 2.6080477
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.163629 20.1074L0.163629 19.48L25.0878 34.1854L25.023 34.8883L0.163629 20.1074Z",
    id: "Rectangle-6",
    fill: "#D4D9DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0449 34.1817L56.8473 15.1984L56.8473 15.841L25.0211 34.9911L25.0449 34.1817Z",
    id: "Rectangle",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "matrix(-1 8.742278E-08 -8.742278E-08 -1 52.52941 31.011593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.626 19.3535L40.4835 7.52068L47.5078 11.9503L21.0206 27.5216L20.626 19.3535Z",
    id: "Rectangle-2",
    fill: "#6758FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10884 12.0062L20.6416 19.3683L21.0956 27.597L0.604504 15.5243L7.10884 12.0062Z",
    id: "Rectangle-3",
    fill: "#3E2FD4",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08659 12.0681L27.6414 0.060588L40.6501 7.7113L20.6244 19.3621L7.08659 12.0681Z",
    id: "Rectangle-4",
    fill: "#4B39FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.49127 15.9372L0.49127 15.422L21.1112 27.4971L21.0576 28.0744L0.49127 15.9372Z",
    id: "Rectangle-6",
    fill: "#D4D9DC",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0758 27.4942L47.3862 11.9062L47.7551 12.1864L21.0561 28.1587L21.0758 27.4942Z",
    id: "Rectangle",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    stroke: "none"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRPool);
export default __webpack_public_path__ + "static/media/rPool.deefbe6ed18de5ecc0acfab2fd2bb652.svg";
export { ForwardRef as ReactComponent };